import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import styled from 'styled-components';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
var ModalFooter = styled(Box)(css({
  marginTop: "auto",
  marginBottom: "16px",
  marginX: ["16px", "24px"]
}));
export { ModalFooter };